import { render } from "./PVStatus.vue?vue&type=template&id=06c2e676&scoped=true"
import script from "./PVStatus.vue?vue&type=script&lang=js"
export * from "./PVStatus.vue?vue&type=script&lang=js"

import "./PVStatus.vue?vue&type=style&index=0&id=06c2e676&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c2e676"]])

export default __exports__